import { render, staticRenderFns } from "./FloatingArrow.vue?vue&type=template&id=ff50b410"
import script from "./FloatingArrow.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingArrow.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports